<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="formgrid grid p-fluid">
    <div class="field col-12">
      <p class="font-normal text-600 m-0">
        <span class="text-primary font-medium">TAKE NOTE:</span> This directly renames
        <strong>{{ subscription?.subscription_account_reference }}</strong> and, if a circuit is
        already linked, its circuit number too. This is a database-only correction - it does
        <strong>not</strong> notify TECH8/Smart OLT. Only use this when the network side was
        never told about the wrong reference in the first place (e.g. correcting a mistake made
        before any activation call ever fired). If Smart OLT already knows this circuit by a
        different number, check with the network team before changing this.
      </p>
    </div>

    <div class="field col-12">
      <label for="new_account_reference">New Account Reference</label>
      <input
        id="new_account_reference"
        type="text"
        pInputText
        formControlName="new_account_reference"
        placeholder="e.g. MTDNXKLG00064"
        class="w-full"
      />
      <small
        class="p-error"
        *ngIf="
          form.get('new_account_reference')?.invalid && form.get('new_account_reference')?.touched
        "
        >Please enter the corrected account reference</small
      >
    </div>

    <div class="field col-12">
      <button
        pButton
        type="submit"
        label="Change Account Reference"
        class="p-button p-button-danger"
        [loading]="submitting"
      ></button>
    </div>

    <div class="field col-12">
      <p-message
        *ngIf="errorMessage !== ''"
        severity="error"
        [text]="errorMessage"
        class="w-full"
      ></p-message>
    </div>
  </div>
</form>
